import { CohortDTOTypeEnum } from '@atlassiansox/phobos-client-ts';

import { cohortTypeSorted } from './slo-panel/types';
import { SLOIndicatorWithGroupType } from './types';

export const formatCohortName = (cohort: string): string =>
  cohort
    .toLowerCase()
    .replace('aws', 'AWS') // it might or might not even have aws prefix
    .replace('_', ' ')
    .replace('-', ' ');

export const getIndicatorRollupCohorts = (indicator: any): string[] => {
  const rollupCohorts: string[] = [];
  cohortTypeSorted.slice(1).some((type: CohortDTOTypeEnum) => {
    if (type === indicator.groupType) return true;
    const cohortName = indicator[type?.toLowerCase()] || '';
    if (cohortName) rollupCohorts.push(cohortName);
    return false;
  });
  const cohorts =
    indicator?.groupType === CohortDTOTypeEnum.Global ? ['-'] : ['global', ...rollupCohorts];
  return cohorts;
};

export const getIndicatorCohortMemberName = (indicator: any): string =>
  indicator?.groupType === CohortDTOTypeEnum.Global
    ? CohortDTOTypeEnum.Global
    : indicator[indicator.groupType?.toLowerCase()];

export const getIndicatorCohortMemberTagName = (
  indicator: SLOIndicatorWithGroupType | undefined
): string => {
  if (!indicator) return '';
  return indicator?.groupType === CohortDTOTypeEnum.Global
    ? CohortDTOTypeEnum.Global
    : `${indicator.groupType}:${getIndicatorCohortMemberName(indicator)}`;
};
